import { gql } from "@apollo/client";

// Field dùng chung cho tạo/cập nhật chương trình chiết khấu
const LOYALTY_PACKAGE_BE_FIELDS = gql`
  fragment LoyaltyPackageBeFields on LoyaltyPackage {
    id
    title
    policy
    startTime
    endTime
    status
    isActive
    numOfPeriods
    createdAt
    updatedAt
    createdBy {
      id
      fullname
    }
  }
`;

export const CREATE_PACKAGE = gql`
  mutation CreatePackage($input: CreateLoyaltyPackageInput!) {
    loyaltyPackage {
      createPackage(input: $input) {
        ...LoyaltyPackageBeFields
      }
    }
  }
  ${LOYALTY_PACKAGE_BE_FIELDS}
`;

export const UPDATE_PACKAGE = gql`
  mutation UpdatePackage($id: ID!, $input: UpdateLoyaltyPackageInput!) {
    loyaltyPackage {
      updatePackage(id: $id, input: $input) {
        ...LoyaltyPackageBeFields
      }
    }
  }
  ${LOYALTY_PACKAGE_BE_FIELDS}
`;

export const SWITCH_PACKAGE_STATUS = gql`
  mutation SwitchPackageStatus($id: ID!, $isActive: Boolean!) {
    loyaltyPackage {
      switchPackageStatus(id: $id, isActive: $isActive) {
        id
        isActive
        title
        status
      }
    }
  }
`;

// Field dùng chung cho tạo/cập nhật gói chiết khấu
const LOYALTY_PERIOD_BE_FIELDS = gql`
  fragment LoyaltyPeriodBeFields on LoyaltyPackagePeriod {
    id
    title
    startTime
    endTime
    timeInterval
    isActive
    productPackageType
    numOfProducts
    loyaltyPackageId
    categoryId
    createdAt
    updatedAt
    createdById
    createdBy {
      id
      fullname
    }
  }
`;

export const CREATE_PERIOD = gql`
  mutation CreatePeriod($input: CreateLoyaltyPackagePeriodInput!) {
    loyaltyPackage {
      createPeriod(input: $input) {
        ...LoyaltyPeriodBeFields
      }
    }
  }
  ${LOYALTY_PERIOD_BE_FIELDS}
`;

// Bật / tắt gói chiết khấu (toggle trong danh sách)
export const SWITCH_PERIOD_STATUS = gql`
  mutation SwitchPeriodStatus($id: ID!, $isActive: Boolean!) {
    loyaltyPackage {
      switchPeriodStatus(id: $id, isActive: $isActive) {
        id
        isActive
        title
        loyaltyPackageId
        startTime
        endTime
      }
    }
  }
`;

// Cập nhật gói chiết khấu (dùng loyaltyPackage.updatePeriod)
export const UPDATE_PERIOD = gql`
  mutation UpdatePeriod($id: ID!, $input: UpdateLoyaltyPackagePeriodInput!) {
    loyaltyPackage {
      updatePeriod(id: $id, input: $input) {
        ...LoyaltyPeriodBeFields
      }
    }
  }
  ${LOYALTY_PERIOD_BE_FIELDS}
`;
